import ApiClient from './ApiClient';

class KanbanColumnsAPI extends ApiClient {
  constructor() {
    super('kanban_columns', { accountScoped: true });
  }
}

class KanbanCardsAPI extends ApiClient {
  constructor() {
    super('kanban_cards', { accountScoped: true });
  }
}

export const KanbanColumnsAPIClient = new KanbanColumnsAPI();
export const KanbanCardsAPIClient = new KanbanCardsAPI();
